import { useAbility } from '../features/auth/abilityContext';
import { useRolesSettled } from '../features/auth/useRolesSettled';
import { lastApp, type AppArea } from '../utils/lastApp';

/**
 * Which of the two apps a path without one opens in: field-only roles
 * (Mitarbeiter, Teamleitung (Junior)) always Feldaufnahme, everyone else the
 * app they used last. Null until the roles have landed — before that, everyone
 * looks like a role-less user, and deciding now would drop office staff into
 * the field app on a cold first login.
 */
export function usePreferredApp(): AppArea | null {
    const ability = useAbility();
    const settled = useRolesSettled();
    if (!settled) {
        return null;
    }
    if (!ability.can('access', 'Office')) {
        return 'field';
    }
    return lastApp() === 'field' ? 'field' : 'office';
}
